import {Link} from 'react-router-dom';
import main from "../feature/new_main.webp";
import main_dsk from "../feature/new_main.webp";
import user1 from "../user1.jpg";
import user3 from "../user3.jpg";
import user4 from "../user4.jpg";
import user5 from "../user5.jpg";
import bannerA1 from "../feature/bannerA1.webp";
import { ArrowUpRight} from 'react-feather';
import {
  FaChartLine,
  FaRedoAlt,
  FaBrain,
  FaComments,
  FaBullseye,
  FaPlug,} from 'react-icons/fa';

import { useState, useEffect } from "react";
import Features from './features';
import SecuritySection from './securitySection';
import PricingCon from './pricing-con';
import FooterCon from './FooterCon';
import HIWorks from './HIWorks';
import FooterHomepage from './footer-homepage';
import ContactIcon from './ContactIcon';
import FeaturesROI from './FeatureROI';
import { Badge } from 'react-bootstrap';

function SellHome(){
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [currency, setcurrency] = useState("");
    const [plan1, setplan1] = useState("");

    async function getLocationAndSetPricing() {
        let countryCode = localStorage.getItem("kadhr_country_code");

        if (!countryCode) {
            try {
                const response = await fetch("https://ipapi.co/json/");
                const data = await response.json();
                countryCode = data.country_code;

                // Save to localStorage
                localStorage.setItem("kadhr_country_code", countryCode);
            } catch (error) {
                // Handle error or use default
                // console.error("Error fetching location:", error);
                countryCode = "US"; // fallback
            }
        }

        let prices, currency;

        if (countryCode === "KE") {
            prices = [0, 999, 2999, 5999];
            currency = "KES";
        } else {
            prices = [0, 10, 30, 50];
            currency = "USD";
        }

        setplan1(prices[0]); 
        setcurrency(currency);
    }

    const fetchTrafficData = async () => {
        try {
            // Get user IP
            const ipResponse = await fetch('https://api.ipify.org?format=json');
            const ipData = await ipResponse.json();
            const userIP = ipData.ip;
    
            // Get device, OS, and browser information
            const userAgent = navigator.userAgent;
            const deviceType = /Mobi|Android/i.test(userAgent) ? 'Mobile' : 'Desktop';
            const os = navigator.platform;
            const browser = (() => {
                if (userAgent.includes('Chrome')) return 'Chrome';
                if (userAgent.includes('Firefox')) return 'Firefox';
                if (userAgent.includes('Safari')) return 'Safari';
                if (userAgent.includes('MSIE') || userAgent.includes('Trident/')) return 'Internet Explorer';
                return 'Unknown';
            })();
    
            // Prepare traffic data
            const trafficData = {
                ip: userIP,
                deviceType,
                os,
                browser,
                timestamp: new Date().toISOString(),
            };
    
            // Check time interval before logging data
            const currentTime = Date.now();
            const lastLogTime = localStorage.getItem('lastLogTimeHome');
            const interval = 300000; // 5 minutes
    
            if (!lastLogTime || currentTime - lastLogTime > interval) {
                const response = await fetch(`${baseUrl}/movement-home/`, {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json'
                    },
                    body: JSON.stringify(trafficData)
                });
    
                if (response.ok) {
                    localStorage.setItem('lastLogTimeHome', currentTime.toString());
                } else {
                    //console.error("Error logging traffic", response.statusText);
                }
            }
        } catch (error) {
            //console.error('Error logging traffic data:', error);
        }
    };
    

    useEffect(()=>{
        getLocationAndSetPricing();   
        fetchTrafficData();  
    },[]);

    
    const features = [        
        {
            icon: <FaPlug size={26} />,
            title: "Plugs Into Your Existing Stack",
            text: "Connect POS systems, online stores, or upload CSVs — Kadhr works on top of your existing data."
        },
        {
            icon: <FaBrain size={26} />,
            title: "Customer Memory Engine",
            text: "Kadhr remembers what every customer buys, how often they buy, and what they’re likely to need next."
        },
        {
            icon: <FaRedoAlt size={26} />,
            title: "Reorder Detection Agent",
            text: "Automatically detects when customers are likely ready to buy again — based on real purchase patterns."
        },
        {
            icon: <FaComments size={26} />,
            title: "AI Relationship Messaging",
            text: "Generates natural, human-like messages that reconnect with customers at the right time."
        },
        {
            icon: <FaBullseye size={26} />,
            title: "Smart Customer Targeting",
            text: "Focus on the right customers — repeat buyers, high spenders, and those at risk of dropping off."
        },
        {
            icon: <FaChartLine size={26} />,
            title: "Repeat Revenue Tracking",
            text: "See exactly how many customers come back — and how much revenue Kadhr recovers."
        }
    ];

    const proofCards = [
        {
            name: "2,180 customers",
            description: "ready to reorder today",
            icon: "👥",
            bg: "rgba(255, 193, 7, 0.15)",
            iconColor: "#b58100",
        },
        {
            name: "+KES 485,240",
            description: "projected from campaign",
            icon: "💰",
            bg: "rgba(25, 135, 84, 0.15)",
            iconColor: "#146c43",
        },
        {
            name: "2× higher purchase",
            description: "48% increase in CLV",
            icon: "📈",
            bg: "rgba(13, 110, 253, 0.15)",
            iconColor: "#0a58ca",
        },
        {
            name: "117 high-value customers",
            description: "likely to buy in 48 hours",
            icon: "🎯",
            bg: "rgba(220, 53, 69, 0.15)",
            iconColor: "#b02a37",
        },
        {
            name: "+KES 79,860 recovered",
            description: "from inactive customers",
            icon: "♻️",
            bg: "rgba(13, 202, 240, 0.15)",
            iconColor: "#087990",
        },
        {
            name: "3.2× more repeat orders",
            description: "from personalized campaigns",
            icon: "🔁",
            bg: "rgba(111, 66, 193, 0.15)",
            iconColor: "#59359a",
        },
        {
            name: "62% revenue from",
            description: "returning customers last week",
            icon: "📊",
            bg: "rgba(64, 204, 162, 0.08)",
            iconColor: "#449e9a",
        },
    ];


    return (
        <main className="mtopcon0 ovrflwhdn" id="up">
            <ContactIcon/>
            <div className="row">
                <div className="col-12 text-center text-white pt-6indx bg-blue0"> 
                    <h2 className='display-4 main-header mb-3 font-bold hddsktp0'><b>Turn sales data into predictable repeat revenue.</b></h2>
                    <h2 className='display-2 main-header mb-3 font-bold hdmobile1'><b>Turn sales data into <br/>predictable repeat revenue.</b></h2>
                    <p className='mb-4 hddsktp0'>
                        Kadhr turns your sales data into perfectly timed, hyper-personalized customer journeys that increase repeat purchases.
                    </p>
                    <p className='mb-4 hmintrotxt0 hdmobile1 font15em'>
                        Kadhr turns your sales data into perfectly timed, hyper-personalized<br/> customer journeys that increase repeat purchases.
                    </p>
                    <p className='pt-2'>
                        <Link className="main-btn btn-hover text-white bg-dark mb-3 me-2" to="/seller/register">Create account for free</Link>
                    </p>

                    <div className='hide'>
                        <div className="d-flex align-items-center justify-content-center mt-3">
                            {/* Text */}
                            <span className="text-light text-right font9 me-2">
                                Trusted by <br/><strong>1K+ Businesses</strong>
                            </span>

                            {/* Profile Images */}
                            <div className="d-flex align-items-center">
                                <div className="position-relative me-1">
                                    <img loading="lazy" src={user1} alt="" className="rounded-circle"/>
                                </div>
                                <div className="position-relative mln10">
                                    <img loading="lazy" src={user4} alt="" className="rounded-circle"/>
                                </div>
                                <div className="position-relative mln10">
                                    <img loading="lazy" src={user5} alt="" className="rounded-circle"/>
                                </div>
                        
                                <div className="position-relative mln10">
                                    <div
                                        className="rounded-circle d-flex align-items-center justify-content-center"
                                        style={{
                                            width: '40px',
                                            height: '40px',
                                            backgroundImage: `url(${user3})`,
                                            backgroundSize: 'cover',
                                            backgroundPosition: 'center',
                                            color: 'white',
                                            fontWeight: 'bold',
                                            backdropFilter: 'blur(2px)',
                                            textShadow: '0 0 5px rgba(0, 0, 0, 0.7)',
                                            border: '2px solid #333',
                                        }}
                                    >
                                        +
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='col-12'>                        
                        <div className="welcome-banner-mini mt-4 br10">
                            <picture>
                                <source media="(min-width: 768px)" srcSet={main_dsk} />
                                <img loading="lazy" src={main} alt="..." className="w-100 h-100" />
                            </picture>
                        </div>
                    </div>
                </div>                     
                
                <div className="col-12 text-center mb-2 mt-4 pt-6indx0 hide">
                    <div className='container'>
                        <div className="row g-4 justify-content-center">
                            {features.map((feature, index) => (
                                <div
                                key={index}
                                className="col-6 col-md-4 col-lg-2 text-center"
                                >
                                <div className="feature-card h-100">
                                    <div className="icon-wrapper1 mb-3">
                                    {feature.icon}
                                    </div>
                                    <h6 className="mb-1 fonth6features"><b>{feature.title}</b></h6>
                                </div>
                                </div>
                            ))}
                        </div>
                        <p className='mt-4 font-bold grey-text'>No manual follow-ups. No guesswork. Just customers coming back.</p>
                    </div>
                </div>

                {/* Most businesses lose 40–70% */}
                <div className="col-12 text-center mt-4 pt-6indx0" id="features">
                    <div className="col-12 mb-2">
                        <div className="container br40">     
                            <div className="row">
                                <div className="col-12">                                               
                                    <div className="retention-copy text-center mw400">
                                        <h2 className="fw800" style={{lineHeight: "1.4em"}}>
                                            Customer Acquisition🎯 costs
                                            <span className='bg-danger rounded-2 pl-04 pr-04 text-white ms-2'>5–10×</span> MORE than <span className="stat-top-bg-success rounded-2 pl-04 pr-04 text-white">Customer Retention❤️</span>. 
                                        </h2>
                                    </div>
                                        <div className='col-12 mt-2 containerwide'>
                                            <div className="marquee-wrapper py-4">
                                                <div className="marquee-track d-flex">

                                                    {[...proofCards, ...proofCards].map((item, index) => (
                                                    <div key={index} className="proof-card mx-2">
                                                        <div
                                                            className="card shadow-sm border-0 p-2"
                                                            style={{
                                                                backgroundColor: item.bg,
                                                                borderRadius: "10px",
                                                            }}
                                                        >
                                                        <div className="d-flex align-items-center">
                                                            <div
                                                            className="me-2 fs-4"
                                                            style={{ color: item.iconColor }}
                                                            >
                                                            {item.icon}
                                                            </div>
                                                            <div>
                                                            <h6 className="mb-0 fw-bold font1 text-left">{item.name}</h6>
                                                            <div className="text-muted font8 text-left">{item.description}</div>
                                                            </div>
                                                        </div>
                                                        </div>
                                                    </div>
                                                    ))}

                                                </div>
                                            </div>
                                        </div>
                                </div>
                            </div>
                        </div>                        
                    </div>
                </div>  
                
                <FeaturesROI/>
                
                <HIWorks/>

                <Features/>

                <PricingCon />
                
                <SecuritySection/>

                <FooterCon/>
                
                <FooterHomepage/>

            </div>
        </main>
    );
}

export default SellHome;
